import {gql} from 'apollo-boost';

export const GET_STUDENTASSIGNMENT = gql`
  query getStudentAssignment($id : ID!){
    getStudentAssignment (
      id: $id
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }

    }
  }
`;

export const GET_STUDENTASSIGNMENTS_BY_FILTER = gql`

  query getStudentAssignmentsByFilter($studentAssignmentFilterInput: StudentAssignmentFilterInput){
    getStudentAssignmentsByFilter (
      studentAssignmentFilterInput:$studentAssignmentFilterInput
    ){
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }

    }
  }
`;

export const GET_STUDENTASSIGNMENTS = gql`
  query getStudentAssignments {
    getStudentAssignments {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const ADD_STUDENTASSIGNMENT = gql`
  mutation addStudentAssignment(
    $classSectionId:          ID
    $classAssignmentId:       ID
    $studentEnrollDetailId:   ID
    $studentId:               ID
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    addStudentAssignment(
      classSectionId: $classSectionId
      classAssignmentId: $classAssignmentId
      studentEnrollDetailId: $studentEnrollDetailId
      studentId: $studentId
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode
    }
  }
`;

export const UPDATE_STUDENTASSIGNMENT = gql`
  mutation updateStudentAssignment(
    $id: ID!,
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    updateStudentAssignment(
      id: $id
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const UPDATE_STUDENTASSIGNMENT_TEACHER_RECEIVE = gql`
  mutation updateStudentAssignmentTeacherReceive(
    $id: ID!,
    $studentAssignmentInput: StudentAssignmentInput!
  ) {
    updateStudentAssignmentTeacherReceive(
      id: $id
      studentAssignmentInput: $studentAssignmentInput
    ) {
      id studentCode remark studentSendDate teacherReceiveDate isTeacherReceive
      uploadPath uploadPathUri uploadFileName
      classSection {
        id sectionNo
      }
      classAssignment {
        id topicLocal topicEng descriptionLocal descriptionEng score dueDate
      }
      studentEnrollDetail {
        id
      }
      student {
        id code firstNameLocal lastNameLocal firstNameEng lastNameEng picturePath
      }
    }
  }
`;

export const DELETE_STUDENTASSIGNMENT = gql`
  mutation deleteStudentAssignment($id: ID!) {
    deleteStudentAssignment(
      id: $id
    ) {
      id studentCode
    }
  }
`;

